import Vue from 'vue'
import Vuex from 'vuex'
import * as types from './mutation-types'
import findIndex from 'lodash/findIndex'
import map from 'lodash/map'
import uniqWith from 'lodash/uniqWith'
import isEqual from 'lodash/isEqual'

// import qs from 'qs'
// import JSURL from 'jsurl'

import LZString from 'lz-string'
import replaceBulk from '../replaceBulk.js'

Vue.use(Vuex)

// const debug = process.env.NODE_ENV !== 'production'

// initial state
// TODO: localstorage
const state = {
  added: []
}

// getters
const getters = {
	favoritesEstates: state => state.added,
	getNumberOfFavoritesEstates: state => (state.added) ? state.added.length : 0
}

// actions
const actions = {
	addToFavorites({ commit }, estate){
		commit(types.ADD_TO_FAVORITES, estate)
  }
}

// mutations
const mutations = {

	[types.ADD_TO_FAVORITES] (state,  estate ) {

    const record = state.added.find(f => (f.id === estate.id && f.estate_group === estate.estate_group && f.estate_type === estate.estate_type))

    if (!record) {
      state.added.push(estate)
    } else {
      let index = findIndex(state.added, {'id': estate.id, 'estate_group': estate.estate_group, 'estate_type': estate.estate_type})
      state.added.splice(index, 1)
    }
    // console.log('state.added', state.added);
  },

  initialiseStore(state) {

    var favs = undefined

    if (window.location.search) {
      var str = (window.location.search).replace(/^\?/,'');
      let str = LZString.decompressFromEncodedURIComponent(decodeURIComponent(str));
      if (str) {
        console.log('str', str);
        str = replaceBulk(str, ['g','t','i'], ['estate_group','estate_type','id']);
        try {
          // let str = JSURL.tryParse(str);
          favs = {"added": JSON.parse(str)}
          console.log('favs', favs);
        } catch (e) {
          console.log('isNotJSON', str);
        }
      }
    }

    // Check if the ID exists
    if(!favs && localStorage.getItem('favorites')) {
      favs = JSON.parse(localStorage.getItem('favorites'))
    }

    if (favs) {
      // Replace the state object with the stored item
      // TODO: sanitize $favorites_post_data estate_group 1 + estate_type 4 => 1
      let index = findIndex(favs.added, {'estate_group': 1, 'estate_type': 4})
      if (index != -1) {
        let _favs = map(favs.added, (o)=>{
          if (o.estate_group == 1 && o.estate_type == 4) {
            o.estate_type = 1
          }
          return o
        })
        let __favs = uniqWith(_favs, isEqual);
        favs.added = __favs
        localStorage.setItem('favorites', JSON.stringify(favs));
      }
      // replace 4 to 1
      // remove dupes
      this.replaceState(
        Object.assign(state, favs)
      );
    }
    console.log('favs', favs);
    console.log('favorites', JSON.parse(localStorage.getItem('favorites')));

  }

}

// one store for entire application
export default new Vuex.Store({
	state,
	// strict: debug,
	getters,
	actions,
	mutations
})


// WEBPACK FOOTER //
// ./src/store/index.js